import "./ProgressBar.css";

const ProgressBar = ({ fill }) => {
  return (
    <div className="isecurion_side_progress_bar">
      <div
        className="isecurion_side_progress_bar_fill"
        style={{ width: `${fill}%` }}
      >
        {fill}%{" "}
      </div>
      {Number(fill) === 0 && (
        <span
          style={{
            color: "#fff",
            paddingLeft: `10px`,
          }}
        >
          0%
        </span>
      )}
    </div>
  );
};

export default ProgressBar;